// Module-level caches of per-user data live for the life of the page, which on
// a kiosk spans many visitors: STATION signs guests in and out of one
// long-lived tab without a reload, so anything cached for visitor #1 would be
// served to visitor #2. Each such cache registers its reset here and
// cleanupCenterUser empties them all when a visitor's session ends. (WEB
// sign-out is a full navigation, which resets module state on its own.)
const resets = new Set()

export const registerSessionCache = (reset) => {
  resets.add(reset)
  return () => {
    resets.delete(reset)
  }
}

export const clearSessionCaches = () => {
  resets.forEach((reset) => reset())
}
